var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgRedWarning = function SvgRedWarning(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29.31,
    height: 29.309,
    viewBox: "0 0 29.31 29.309",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14928",
    "data-name": "Group 14928",
    transform: "translate(-908.69 -428.982)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14257",
    "data-name": "Group 14257",
    transform: "matrix(1, -0.017, 0.017, 1, 908.69, 429.485)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14176",
    "data-name": "Group 14176",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11222",
    "data-name": "Group 11222",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7418",
    "data-name": "Path 7418",
    d: "M14.406,0A14.406,14.406,0,1,1,0,14.406,14.406,14.406,0,0,1,14.406,0Z",
    fill: "#fc7b7b"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14258",
    "data-name": "Group 14258",
    transform: "matrix(1, -0.017, 0.017, 1, 921.586, 437.035)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8510",
    "data-name": "Path 8510",
    d: "M.476.471A1.61,1.61,0,0,1,3.224,1.609a1.457,1.457,0,0,1-.473,1.11,1.687,1.687,0,0,1-2.279,0A1.457,1.457,0,0,1,0,1.609,1.552,1.552,0,0,1,.48.467Z",
    transform: "translate(0.036 11.683)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8511",
    "data-name": "Path 8511",
    d: "M.631,5.758Q.355,4.357.218,3.51T.04,2.27Q0,1.867,0,1.57A1.506,1.506,0,0,1,.453.432a1.875,1.875,0,0,1,2.394,0A1.506,1.506,0,0,1,3.3,1.57q0,.294-.039.7T3.088,3.5q-.137.833-.413,2.248T1.93,9.49H1.377Q.908,7.172.631,5.758Z",
    transform: "translate(0 0)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRedWarning, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/redWarning.5b800320.svg";
export { ForwardRef as ReactComponent };